import React from 'react';
import { ArrowRight, MessageCircle, Phone, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hello! I would like to know more about your AC services.");
    window.open(`https://wa.me/97474408801?text=${message}`, '_blank');
  };

  return (
    <section className="relative bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%236366f1' fill-opacity='0.1'%3E%3Cpath d='M20 20c0 11.046-8.954 20-20 20v-40c11.046 0 20 8.954 20 20z'/%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            {/* Badge */}
            <div className="inline-flex items-center bg-white rounded-full px-4 py-2 shadow-lg border border-gray-200 mb-8">
              <CheckCircle size={16} className="text-green-500 mr-2" />
              <span className="text-gray-700 font-medium">Trusted AC Experts in Qatar</span>
            </div>
            
            {/* Main Heading */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Professional Air Conditioning 
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600">
                Services You Can Rely On
              </span>
            </h1>
            
            {/* Tagline */}
            <p className="text-xl text-gray-600 mb-6 leading-relaxed">
              From installation to repair, spare parts to 24/7 maintenance — Nebula delivers 
              reliable and affordable services for businesses and homes across Qatar.
            </p>
            
            {/* Key Points */}
            <div className="flex flex-wrap gap-4 mb-8">
              <div className="flex items-center bg-white rounded-lg px-4 py-2 shadow-sm border border-gray-200">
                <CheckCircle size={16} className="text-green-500 mr-2" />
                <span className="text-gray-700 font-medium">24/7 Emergency</span>
              </div>
              <div className="flex items-center bg-white rounded-lg px-4 py-2 shadow-sm border border-gray-200">
                <CheckCircle size={16} className="text-green-500 mr-2" />
                <span className="text-gray-700 font-medium">Licensed Technicians</span>
              </div>
              <div className="flex items-center bg-white rounded-lg px-4 py-2 shadow-sm border border-gray-200">
                <CheckCircle size={16} className="text-green-500 mr-2" />
                <span className="text-gray-700 font-medium">Affordable Pricing</span>
              </div>
            </div>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <Link
                to="/contact"
                className="group bg-gradient-to-r from-purple-600 to-blue-600 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:from-purple-700 hover:to-blue-700 transition-all duration-300 transform hover:scale-105 flex items-center justify-center space-x-2 shadow-xl"
              >
                <span>Get a Free Quote</span>
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </Link>
              
              <button
                onClick={handleWhatsAppClick}
                className="group bg-green-500 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:bg-green-600 transition-all duration-300 transform hover:scale-105 flex items-center justify-center space-x-2 shadow-xl"
              >
                <MessageCircle size={18} />
                <span>WhatsApp Us</span>
              </button>
            </div>
            
            {/* Contact Info */}
            <div className="flex items-center text-gray-600">
              <Phone size={20} className="mr-3 text-purple-600" />
              <div>
                <a href="tel:+97470086090" className="text-xl font-bold text-gray-900 hover:text-purple-600 transition-colors">
                  +974 7008 6090
                </a>
                <p className="text-sm">Available 24/7 for Emergency Services</p>
              </div>
            </div>
          </div>
          
          {/* Image */}
          <div className="relative">
            <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200">
              <img
                src="/img2.jpg"
                alt="Professional AC Technician"
                className="w-full h-80 object-cover rounded-xl"
              />
            </div>
            
            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 bg-gradient-to-r from-purple-600 to-blue-600 text-white p-4 rounded-xl shadow-xl">
              <div className="text-center">
                <div className="text-2xl font-bold">10+</div>
                <div className="text-sm">Years Experience</div>
              </div>
            </div>
            
            <div className="absolute -bottom-4 -left-4 bg-white border border-gray-200 p-4 rounded-xl shadow-xl">
              <div className="text-center">
                <div className="text-2xl font-bold text-green-600">24/7</div>
                <div className="text-sm text-gray-600">Emergency</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;